import { render, staticRenderFns } from "./training-distribution.vue?vue&type=template&id=6ab85c2a&"
import script from "./training-distribution.vue?vue&type=script&lang=js&"
export * from "./training-distribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports